<template>
	<div class="collection">
		<ul>
			<li v-for="(item,index) in list" :key="index">
				<router-link :to="{path:'/detail',query:{
					id:item.lotId
				}}">
					<img :src="$pub.imageUrl+item.lotPictrueUrl" :alt="item.lotName">
					<span>{{item.lotName}}</span>
				</router-link>
			</li>
		</ul>
		<ul class="empty" v-if="list.length == 0">
			<el-empty></el-empty>
		</ul>
		<div class="pager" v-if="total>pageSize">
			<el-pagination background layout="total, prev, pager, next" :total="total" :pager-count="11"
				:page-size="pageSize" :current-page="currentPage" @current-change="pageChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'collection',
		data() {
			return {
				total: 0,
				pageSize: 12,
				currentPage: 1,
				list: [],
				keyword: ''
			};
		},
		watch: {
			getKeyword(keyword){
				this.keyword = keyword
				this.fetchData()
			}
		},
		computed: {
			getKeyword(){
				return this.$store.state.spaceKeyword
			}
		},
		methods: {
			pageChange(e) {
				this.currentPage = e
				this.fetchData()
			},
			fetchData() {
				this.$api.frontCompleteList({
					memberId: this.$store.state.userinfo.userId,
					pageSize: this.pageSize,
					pageNum: this.currentPage,
					lotName: this.keyword
				}, res => {
					if (res.code == 200) {
						this.list = res.data.list
						this.total = res.data.total
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.collection {
		width: 100%;

		ul {
			width: 100%;
			display: flex;
			flex-wrap: wrap;

			li {
				width: 22%;
				height: 240px;
				margin-right: 4%;
				margin-bottom: @vue-spacing-col-base*2;

				a {
					width: 100%;
					height: 100%;
					display: block;
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}

					span {
						width: 100%;
						line-height: 24px;
						padding: @vue-spacing-col-sm @vue-spacing-row-sm;
						box-sizing: border-box;
						background: @vue-bg-color-mask;
						color: @vue-text-color-inverse;
						display: block;
						position: absolute;
						bottom: 0px;
						left: 0px;
						font-size: @vue-font-size-min;
					}
				}
			}

			li:nth-child(4n) {
				margin-right: 0px;
			}
		}
		
		.empty{
			justify-content: center;
		}

		.pager {
			width: 100%;
			height: 70px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
		}
	}
</style>
